import { render, staticRenderFns } from "./FonepayPayment.vue?vue&type=template&id=f495ec10&scoped=true&"
import script from "./FonepayPayment.vue?vue&type=script&lang=js&"
export * from "./FonepayPayment.vue?vue&type=script&lang=js&"
import style0 from "./FonepayPayment.vue?vue&type=style&index=0&id=f495ec10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f495ec10",
  null
  
)

export default component.exports